import { createContext, type ReactNode, useContext } from "react";

import {
  type NotificationItems,
  useNotificationsController,
} from "components/notifications/hooks";

const NotificationContext = createContext<NotificationItems | null>(null);

/**
 * Read the shared notification state. Every consumer sees the same list, the
 * same drawer state, and the same `markRead`/`dismiss`/`openDrawer` functions —
 * the provider owns them, so a navigation or a dismiss produces one write.
 */
export const useNotifications = (): NotificationItems => {
  const ctx = useContext(NotificationContext);
  if (!ctx)
    throw new Error(
      "useNotifications must be used within NotificationProvider",
    );
  return ctx;
};

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const notifications = useNotificationsController();

  return (
    <NotificationContext.Provider value={notifications}>
      {children}
    </NotificationContext.Provider>
  );
};
